import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import { IMarqueeValidationError, ValidateMarqueeGroupProps } from "../types/interfaces";

/**
 * 驗證跑馬燈組的日期範圍
 * @param t 翻譯函數
 * @param groupIndex 組索引
 * @param groupData 組資料
 * @param allGroupsData 所有組資料
 * @param MIN_DATE 最小日期
 * @returns 驗證結果
 */
export const validateMarqueeGroupDateRange = ({
    t,
    groupIndex,
    groupData,
    allGroupsData,
    MIN_DATE,
}: ValidateMarqueeGroupProps): IMarqueeValidationError[] => {
    const errors: IMarqueeValidationError[] = [];
    dayjs.extend(customParseFormat);
    const PARSE_FORMAT = "YYYY/MM/DD HH:mm";

    const startDate = dayjs(groupData.start_at, PARSE_FORMAT, true);
    const endDate = dayjs(groupData.end_at, PARSE_FORMAT, true);

    // 跳過無效日期
    if (!startDate.isValid() || !endDate.isValid()) {
        return errors;
    }

    // 驗證 1: 開始時間不能早於今天
    if (startDate.isBefore(MIN_DATE, "day")) {
        errors.push({
            type: "start_before_today",
            message: t("APPWIDGET.DATE_VALIDATION_TOO_EARLY") || `開始時間不能早於今天`,
        });
    }

    // 驗證 2: 結束時間必須晚於開始時間
    if (endDate.isBefore(startDate, "minute")) {
        errors.push({
            type: "end_before_start",
            message: t("APPWIDGET.DATE_VALIDATION_END_BEFORE_START") || `開始時間不可晚於結束時間`,
        });
    }

    // 驗證 3: 檢查與其他組的時間重疊
    allGroupsData.forEach((otherGroup, otherIndex) => {
        if (otherIndex === groupIndex) return;

        const otherStart = dayjs(otherGroup.start_at, PARSE_FORMAT, true);
        const otherEnd = dayjs(otherGroup.end_at, PARSE_FORMAT, true);

        if (!otherStart.isValid() || !otherEnd.isValid()) return;

        const noOverlap =
            endDate.isSame(otherStart) ||
            otherEnd.isSame(startDate) ||
            endDate.isBefore(otherStart) ||
            otherEnd.isBefore(startDate);

        if (!noOverlap) {
            errors.push({
                type: "time_overlap",
                message:
                    t("APPWIDGET.MARQUEE_TIME_OVERLAP", {
                        index1: groupIndex + 1,
                        index2: otherIndex + 1,
                    }) || `第 ${groupIndex + 1} 組與第 ${otherIndex + 1} 組時間重疊`,
                conflictGroupIndex: otherIndex,
            });
        }
    });

    return errors;
};
